<template>
    <div id="ModalErrorClaimStatus">
         <b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
            <b-row>
                <b-col lg="12" md="12" sm="12"> 
                        <MdTablePaginationClient 
                            v-bind:fields="Fields"
                            v-bind:items="this.items"
                            v-bind:totalRows="totalRows"                         
                            v-bind:isReadOnly="false"          
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"            
                            :RowClick="RowClick"                          
                            :onRowSelected="onRowSelected"
                            :perPageFunction="PerPageFunction">
                        </MdTablePaginationClient>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ClaimBatchStatusModal",
    props: {
        ModalId: String,
        TitleWindow: String,  
        items:Array,
        ErrorMessage:String,
    },
    data() {
        return {
            ShowMessageIsEmpty:false,
            pageOptions: [5, 10, 15 ],
            totalRows: this.items.length,
            currentPage: 1,
            perPage: 1.,
             Fields: [         
              { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' },
              { key: 'message', sortable: true, label: this.$t('Shared.Message'), class: 'text-rigth' },
            ]
        }
    },

    methods:{
        RowClick(){

        },
        onRowSelected(){

        },
        onFiltered(){

        },
        pageChanged(){

        },
        PerPageFunction(){

        },
        emitEventCancel(){
            this.$emit('getCodeConditionOK',true);
        },

        emitEventOK(){
            this.$emit('getCodeConditionOK',true);
        }
    }
}
</script>